module.exports = __webpack_public_path__ + "img/func.44b2a508.jpg";